<template>
  <div
    class="card component"
    :class="cardClasses"
  >
    <UiCardMedia
      v-if="media"
      class="card-media"
      :media="media"
      :style="mediaStyle"
    >
      <slot name="media"></slot>
    </UiCardMedia>
    <UiCardTitle v-if="title" large>{{ title }}</UiCardTitle>
    <UiCardSubtile v-if="subTitle">{{ subTitle }}</UiCardSubtile>
    <UiCardBodyText v-if="bodyText || $slots.bodyText">
      <slot name="card-body-text">{{ bodyText }}</slot>
    </UiCardBodyText>
    <UiCardActions v-if="$slots.actions">
      <slot name="actions"></slot>
    </UiCardActions>
  </div>
</template>

<script>
  import UiCardMedia from './UiCardMedia'
  import UiCardTitle from './UiCardTitle'
  import UiCardSubtitle from './UiCardSubtitle'
  import UiCardBodyText from './UiCardBodyText'
  import UiCardActions from './UiCardActions'
  export default {
    name: 'card',
    props: {
      title: String,
      subTitle: String,
      bodyText: String,
      media: String,
      mediaHeight: {
        type: String,
        default: '320px',
      },
      themeDark: Boolean,
      img: String,

      tag: {
        type: String,
        default: 'div'
      },
      width: [String, Number]
    },
    components: {
      UiCardMedia,
      UiCardTitle,
      UiCardSubtitle,
      UiCardBodyText,
      UiCardActions
    },
    data() {
      return {
        previewImageData: ''
      }
    },
    computed: {
      mediaStyle() {
        return {
          height: this.mediaHeight
        }
      },
      cardClasses() {
        return {
          'card--theme-dark': this.themeDark,
        }
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/UiCard.vue